/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect, useState } from "react";

const enum fields {
    enableThirdPartyCode = "enableThirdPartyCode",
    scriptSrc = "scriptSrc",
    formID = "formID",
    loadFormParam1 = "loadFormParam1",
    loadFormParam2 = "loadFormParam2",
    loadFormParam3 = "loadFormParam3",
    loadFormRedirectUrl = "loadFormRedirectUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.enableThirdPartyCode]: boolean;
        [fields.scriptSrc]: string;
        [fields.formID]: string;
        [fields.loadFormParam1]: string;
        [fields.loadFormParam2]: string;
        [fields.loadFormParam3]: string;
        [fields.loadFormRedirectUrl]: string;
    };
}

export const EmbedExternalCode: React.FunctionComponent<Props> = props => {
    const [isLoaded, setIsLoaded] = useState(false);
    const marketoScriptId = "mktoForms";
    const formId = props.fields.loadFormParam3;
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    useEffect(() => {
        if (props.fields.enableThirdPartyCode && isLoaded === false) {
            loadScript();
        }
        setIsPageLoaded(true);
    }, []);

    useEffect(() => {
        if (isLoaded) {
            let scriptCall = null;
            let scriptDiv = null;
            scriptDiv = document.getElementById("MktoForms2Div");
            if (scriptDiv !== null) {
                scriptDiv.remove();
            }
            scriptDiv = document.createElement("div");
            scriptDiv.id = "MktoForms2Div";
            scriptCall = document.getElementById("MktoForms2Form2");
            if (scriptCall !== null) {
                scriptCall.remove();
            }
            scriptCall = document.createElement("script");
            scriptCall.id = "MktoForms2Form2";
            scriptCall.innerHTML = "";
            scriptCall.innerHTML = `MktoForms2.loadForm("${props.fields.loadFormParam1}", "${props.fields.loadFormParam2}", "${props.fields.loadFormParam3}", function(form){form.onSuccess(function(values, followUpUrl){location.href = "${props.fields.loadFormRedirectUrl}";return false;});});`;
            scriptDiv.appendChild(scriptCall);
            document.body.appendChild(scriptDiv);
        }
    }, [isLoaded, formId, isPageLoaded]);

    const loadScript = () => {
        if (props.fields.enableThirdPartyCode && isLoaded === false) {
            const scriptCall = document.getElementById(marketoScriptId);
            if (scriptCall !== null) {
                scriptCall.remove();
            }
            const s = document.createElement("script");
            s.id = "MktoFormsScript";
            s.id = marketoScriptId;
            s.type = "text/javascript";
            s.async = true;
            s.src = props.fields.scriptSrc;
            s.onload = () => setIsLoaded(true);
            document.getElementsByTagName("head")[0].appendChild(s);
        }
    };

    return <>{isLoaded && <form key={`mktoForm_${formId}`} id={`mktoForm_${formId}`}></form>}</>;
};

const widgetModule: WidgetModule = {
    component: EmbedExternalCode,
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.enableThirdPartyCode,
                displayName: "Enable Third Party Code Injection?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                fieldType: "General",
                name: fields.scriptSrc,
                editorTemplate: "TextField",
                displayName: "Script Src",
                defaultValue: "//313-KJQ-147.mktoweb.com/js/forms2/js/forms2.min.js",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.formID,
                editorTemplate: "TextField",
                displayName: "Form ID",
                defaultValue: "mktoForm_5506",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam1,
                editorTemplate: "TextField",
                displayName: "Load Form Param 1",
                defaultValue: "//313-KJQ-147.mktoweb.com",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam2,
                editorTemplate: "TextField",
                displayName: "Load Form Param 2",
                defaultValue: "313-KJQ-147",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam3,
                editorTemplate: "TextField",
                displayName: "Load Form Param 3",
                defaultValue: "5506",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormRedirectUrl,
                editorTemplate: "TextField",
                displayName: "Redirect URL",
                defaultValue: "",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
        ],
    },
};
export default widgetModule;